import {connect, useSelector} from 'react-redux'
import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
  Children,
} from "react";
import { createPortal } from "react-dom";
import config from "../../config";
import _ from "lodash";
import debounce from "lodash.debounce";
import session from "../../utils/session"
// import tailwindStyles from "!raw-loader!../../tailwind.generated.css"; // Load the compiled Tailwind CSS as a string
import { initRoom, leaveRoom } from '../../io.js';

import {
  CalendarFilled,
  CopyOutlined,
  EditOutlined,
  EyeOutlined,
  FilePdfFilled,
  LaptopOutlined,
  NotificationOutlined,
  PaperClipOutlined,
  RobotOutlined,
  StarFilled,
  UserOutlined,
} from "@ant-design/icons";
import { Badge, Card, Empty, Mentions, MenuProps, Popover, SegmentedProps, Select, Modal } from "antd";
import {
  ConfigProvider,
  Breadcrumb,
  Input,
  Layout,
  Menu,
  theme,
  Flex,
  Splitter,
  TreeSelect,
  Tooltip,
  Typography,
  Col,
  Row,
  Radio,
  Segmented,
  Button,
  Dropdown,
  message,
  Space,
} from "antd";

import {useInboxV2Styles} from './inboxv2-styles';
import './ai-assistant.css';

import { CheckboxGroupProps } from "antd/es/checkbox";
const { TextArea } = Input;

import {
  AppstoreOutlined,
  BellOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  ContactsOutlined,
  FilterOutlined,
  MailOutlined,
  SendOutlined,
  MessageOutlined,
  SettingOutlined,
  InboxOutlined,
  TagsOutlined,
  StarOutlined,
  FilePdfOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import MessageList from "./components/MessageList/MessageList";
import ScrollableLoadMore from "./components/ScrollableLoadMore";
import ThreadList from "./components/Threads/ThreadList";
import { TileAvatar } from "./components/helpers/ui";

// import { useStore } from './inbox-store'
import FullPageLoader from './components/FullPageLoader/FullPageLoader';
import { MenuItemType } from 'antd/es/menu/interface';
import AIAssistantMessageInputField from './components/AiAssistantMessageInputField/AIAssistantMessageInputField';
import ScreeningAssistantPanel from "./ScreeningAssistantPanel";
import Dragger from 'antd/es/upload/Dragger';
import ExploreAssistants from './ExploreAssistants';
import { createAIAssistant, getAIConversations, getAIConversation } from "./resources";

const { Header, Content, Sider, Footer } = Layout;
const { Text, Title } = Typography;

const { SHOW_PARENT } = TreeSelect;


type MenuItem = Required<MenuProps>["items"][number];


/**dropdown */


const menuItems: MenuProps["items"] = [
  {
    label: "Delete Contact",
    key: "1",
    icon: <UserOutlined />,
  },
];



const onMessageInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) => {
  console.log("Change:", e.target.value);
};

/** end dropdown */

const AIAssistants = ({ selectedCompany, selectedCompanyData,initRoom })=> {

  const {contentStyle, headerStyle, layoutStyle, PanelStyle, AItextingInputAreaStyle} = useInboxV2Styles();
  

  
  // State to toggle explore view
  const [showExplore, setShowExplore] = useState(false);

  // State for create assistant modal
  const [showCreateModal, setShowCreateModal] = useState(false);
  // Track if modal just opened for clone
  const justOpenedForClone = useRef(false);

  // Form state
  const [assistantName, setAssistantName] = useState("");
  const [assistantDescription, setAssistantDescription] = useState("");
  const [instructions, setInstructions] = useState("");
  const [creating, setCreating] = useState(false);

  // Key to force ExploreAssistants remount/refresh
  const [exploreKey, setExploreKey] = useState(0);

  // Currently opened conversation (when a conversation on the left is clicked)
  const [selectedConversation, setSelectedConversation] = useState<any | null>(null);
  const [loadingConversation, setLoadingConversation] = useState(false);

  // Conversation titles from API
  const [conversationTitles, setConversationTitles] = useState<{id: string, title: string}[]>([]);
  const [campaignOptions, setCampaignOptions] = useState<MenuItemType[]>([]);

  useEffect(() => {
    getAIConversations().then((res) => {
      if (res?.data && res.data.length > 0) {
        setConversationTitles(res.data.map((conv) => ({ id: conv.id, title: conv.title })));
        setCampaignOptions(
          res.data.map((conv, i) => ({
        key: conv.id,
        value: conv.id,
        label: (
          <Tooltip title={conv.title} placement='right'>
            {conv.title}
          </Tooltip>
        ),
          }))
        );
        // Open the first conversation right away
        getAIConversation(res.data[0].id).then((convRes) => {
          if (convRes?.data) {
            setSelectedConversation(convRes.data);
          }
        });
        setShowExplore(false);
      } else {
        // No conversations, open assistants explorer
        setShowExplore(true);
        setSelectedConversation(null);
      }
    });
  }, []);

/*** end campaign states */

/*** tag states */

const [tagOptions,setTagOptions]=useState<MenuItemType[]>([]);



 
  const items: MenuItem[] = [
    {
      key: "assistants",
      label: "Assistants",
      icon: <RobotOutlined />,
    },
    {
      type: "divider",
    },
    {
      key: "sub4",
      label: "All Chats",
      icon: <MessageOutlined />,
      children: campaignOptions,
      className: "no-expand-icon",
    },
    // {
    //   key: "sub5",
    //   label: "Tags",
    //   icon: <TagsOutlined />,
    //   children: tagOptions
    // },
  ];




/***** */

// Handle create assistant form submit
const handleCreateAssistant = async (e) => {
  e.preventDefault();
  // Get user_id from localStorage
  let userId = null;
  try {
    const userData = localStorage.getItem("userData");
    if (userData) {
      const parsed = JSON.parse(userData);
      userId = parsed?.id ?? null;
    }
  } catch {}
  if (!assistantName.trim() || !instructions.trim() || !userId) {
    message.error("Name, Instructions, and user must be provided.");
    return;
  }
  setCreating(true);
  try {
    await createAIAssistant({
      name: assistantName,
      description: assistantDescription,
      instructions,
      user_id: userId,
    });
    message.success("Assistant created!");
    setShowCreateModal(false);
    setAssistantName("");
    setAssistantDescription("");
    setInstructions("");
    setExploreKey(k => k + 1); // force ExploreAssistants remount/refresh
    // Optionally: refresh assistants list in ExploreAssistants
  } catch (err) {
    message.error("Failed to create assistant");
    console.error(err);
  } finally {
    setCreating(false);
  }
};

  // Handler to refresh conversations and select a new one
  const handleNewConversation = async (newConv) => {
    setSelectedConversation(newConv);
    setShowExplore(false);
    setLoadingConversation(true);
    try {
      await refreshConversations();
    } catch (err) {
      // Optionally handle error
    } finally {
      setLoadingConversation(false);
    }
  };

  // Standalone refresh for sidebar/conversation list
  const refreshConversations = async () => {
    try {
      const res = await getAIConversations();
      if (res?.data && res.data.length > 0) {
        setConversationTitles(res.data.map((conv) => ({ id: conv.id, title: conv.title })));
        setCampaignOptions(
          res.data.map((conv, i) => ({
            key: conv.id,
            value: conv.id,
            label: (
              <Tooltip title={conv.title} placement='right'>
                {conv.title}
              </Tooltip>
            ),
          }))
        );
      }
    } catch (err) {
      // Optionally handle error
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Splitter: {
            splitBarDraggableSize: 20,
            splitBarSize: 2,
            splitTriggerSize: 2,
          },
        },
      }}
    >
      <Flex
        gap="middle"
        vertical
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <Layout style={layoutStyle}>
          <Splitter>
            {/** first panel */}
            <Splitter.Panel defaultSize="20%" min="20%" max="30%">
              <Layout style={layoutStyle}>
                {/* <Header style={headerStyle}>
                  
                </Header> */}
                <Content style={contentStyle}>
                  <Menu
                    className="aiAssistantSideMenu"
                    onClick={async (e) => {
                      // If user clicked the assistants button, show Explore view
                      if (e.key === "assistants") {
                        setShowExplore(true);
                        setSelectedConversation(null);
                        return;
                      }

                      // Otherwise assume it's a conversation id -- fetch and open it
                      setLoadingConversation(true);
                      try {
                        const res = await getAIConversation(e.key);
                        if (res?.data) {
                          setSelectedConversation(res.data);
                          setShowExplore(false);
                        } else {
                          message.error("Failed to load conversation");
                        }
                      } catch (err) {
                        console.error(err);
                        message.error("Failed to load conversation");
                      } finally {
                        setLoadingConversation(false);
                      }
                    }}
                    style={{
                      minWidth: 0,
                      width: "100%",
                      flex: "auto",
                      borderRight: "none",
                    }}
                    defaultSelectedKeys={["inbox"]}
                    openKeys={["sub4"]}
                    mode="inline"
                    items={items}
                    selectedKeys={showExplore ? ["assistants"] : (selectedConversation ? [selectedConversation.id] : ["sub4"])}
                    // Prevent closing the All Chats dropdown
                    onOpenChange={() => {}}
                  />
                </Content>
              </Layout>
            </Splitter.Panel>
            {/** second panel */}
            <Splitter.Panel defaultSize="80%" min="70%">


              {showExplore ? (
                <ExploreAssistants
                  key={exploreKey}
                  conversationTitles={conversationTitles.map(c => c.title)}
                  layoutStyle={layoutStyle}
                  headerStyle={headerStyle}
                  PanelStyle={PanelStyle}
                  onCreateClick={(assistant) => {
                  
                    setShowCreateModal(true);
                   

                    if(assistant){
                      setAssistantName(assistant.name);
                      setAssistantDescription(assistant.description);
                      setInstructions(assistant.instructions);
                    }

                    justOpenedForClone.current = !!assistant;
                  }}
                  onChatClick={() => setShowExplore(false)}
                  onNewConversation={handleNewConversation}
                  onRefreshConversations={refreshConversations}
                />
              ) : (
                <ScreeningAssistantPanel
                  layoutStyle={layoutStyle}
                  headerStyle={headerStyle}
                  PanelStyle={PanelStyle}
                  AItextingInputAreaStyle={AItextingInputAreaStyle}
                  selectedConversation={selectedConversation}
                  loadingConversation={loadingConversation}
                  onNewConversation={handleNewConversation}
                />
              )}
            </Splitter.Panel>
          </Splitter>
        </Layout>
        {/* <FullPageLoader isSpinning={spinning} /> */}
      </Flex>

      <Modal
        title="Create Assistant"
        open={showCreateModal}
        onCancel={() => {
          setShowCreateModal(false);
          setAssistantName("");
          setAssistantDescription("");
          setInstructions("");
        }}
        footer={null}
        width={600}
      >
        <form style={{ display: 'flex', flexDirection: 'column', gap: 20 }} onSubmit={handleCreateAssistant}>
          <Input
            placeholder="Name your Assistant"
            value={assistantName}
            onChange={e => setAssistantName(e.target.value)}
            required
          />
          <Input
            placeholder="Add a short description what this assistant does"
            value={assistantDescription}
            onChange={e => setAssistantDescription(e.target.value)}
          />
          <Input.TextArea
            placeholder="Instructions (How should this assistant behave?)"
            value={instructions}
            onChange={e => setInstructions(e.target.value)}
            rows={4}
            required
            className="dark-placeholder"
          />
          {/* File upload is optional and not sent to API */}
          <Dragger {...{
            name: 'file',
            multiple: true,
            action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
            onChange(info) {
              const { status } = info.file;
              if (status !== 'uploading') {
                console.log(info.file, info.fileList);
              }
              if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
              } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
              }
            },
            onDrop(e) {
              console.log('Dropped files', e.dataTransfer.files);
            },
          }}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file(s) to this area to upload additional Knowledge</p>
            <p className="ant-upload-hint">
              Conversations with your Assistant can potentially reveal part or all of the files uploaded.
            </p>
          </Dragger>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
            <Button onClick={() => setShowCreateModal(false)} disabled={creating}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={creating}>
              Create
            </Button>
          </div>
        </form>
      </Modal>
    </ConfigProvider>
  );
}






const mapStateToProps = (state) => {
  const {
    company: { selectedCompany, selectedCompanyData },
  } = state
  return { selectedCompany, selectedCompanyData }
}
const mapDispatchToProps = (dispatch) => {
  return {
    initRoom(id) {
      return initRoom(id)
    },
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(AIAssistants)